import React from "react";
import { Link } from "react-router-dom";

export default function Nav(props) {
  return (
    <nav className="Nav">
      <button>
        <Link to={"/"}>Bookmark List</Link>
      </button>
      <button>
        <Link to={"add-bookmark"}>Add Bookmark</Link>
      </button>
    </nav>
  );
}

/*
      <button onClick={() => props.clickPage("list")}>
        Bookmark List
      </button>{" "} 
            <button onClick={() => props.clickPage("add")}>Add Bookmark</button>

      */
